import React from 'react';
import { InputRef, Typography } from 'antd';
import styled from 'styled-components';
import { sizes } from 'theme';
import AntFormItem from 'antd/lib/form/FormItem';
import { CheckCircleFilled } from '@ant-design/icons';
import Input from 'components/new-ui/base/input/Input';

type StyledInputProps = {
    showSuccess: boolean;
    condensed?: boolean;
    inputRef?: React.Ref<HTMLInputElement>;
} & React.ComponentProps<typeof Input>;

const RawStyledInput = styled(Input)<{
    showSuccess: boolean;
    condensed?: boolean;
}>`
    width: 100%;
    border-radius: ${sizes.radiusMd}px;

    &.ant-input-affix-wrapper-disabled:hover {
        border-color: var(--gray-5);
    }

    &.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled) {
        &:focus,
        &:active {
            border: 1px solid var(--brand-6);
            box-shadow: 0px 0px 4px 0px var(--box-shadow-1);
        }

        &:hover {
            border: 1px solid var(--brand-5);
        }
    }

    &.ant-input-affix-wrapper-focused {
        border: 1px solid var(--brand-6);
        box-shadow: 0px 0px 4px 0px var(--box-shadow-1);
    }
`;

export const StyledInput = React.forwardRef<InputRef, StyledInputProps>(({ className, ...props }, ref) => {
    return <RawStyledInput {...props} ref={ref} className={className} />;
});

export const StyledLabel = styled.label`
    display: flex;
    align-items: center;
    gap: 6px;
    white-space: nowrap;
`;

export const StyledLabelRequiredSymbolWrapper = styled.span`
    color: var(--error-normal);
    font-weight: 600;
    font-size: 1.4rem;
    line-height: 2.2rem;
`;

export const FormRow = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const InputDiv = styled.div`
    max-width: 100%;
    width: 100%;
    display: flex;
    gap: 1rem;
`;

export const FormItem = styled(AntFormItem)`
    width: 100%;
    margin-bottom: 0;
    display: flex;
    align-items: center;
    & .ant-form-item-row {
        width: 100%;
    }
`;

export const SelectAccountNumbers = styled(Typography.Text)`
    cursor: pointer;
`;

export const LabelDiv = styled.div<{ condensed?: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: ${({ condensed }) => (condensed ? 0 : '0.2rem')};
`;

export const ViewOnlyLabel = styled(Typography.Text)`
    margin-right: 0.5rem;
`;

export const SuccessIcon = styled(CheckCircleFilled)`
    color: var(--success-normal);
`;

export const SuccessDiv = styled.div`
    width: 100%;
    margin-bottom: 1.1rem;
`;
